export default __webpack_public_path__ + "static/library-8bfa123aa66ee03d467a5e7c441b27ef.jpeg";